import React from "react";
import Typography from "../../../Typography";
import UserPhoto from "../../../UserPhoto/userphoto";

import { ReactComponent as CallIcon } from "../../../../build/images/viewactioncall.svg";
import { ReactComponent as ListeningIcon } from "../../../../build/images/teams/monitorias/sigilosa.svg";
import { ReactComponent as SussurroIcon } from "../../../../build/images/viewactionprofile.svg";
import { ReactComponent as PointMessageIcon } from "../../../../build/images/viewactionmessagepoint.svg";

import "./header-contact-infos.styles.css";
import { Tooltippy } from "../../../../actions/Tippy";
import { useHeaderContactInfos } from "./hooks/useHeaderContactInfos";

const HeaderContactInfos = ({
  attendant,
  typeMonitoring,
  setTypeMonitoring,
  hasVoice,
  InitialCall,
  InitialMonitoringAction,
  selectedChat,
  setSelectedChat,
}) => {
  const {
    ChatSimult,
    InfoUsers,
    MonitoringSimult,
    ClientUserMonitors,
    Monitoring,
  } = useHeaderContactInfos();
  return (
    <div className="header-contact-infos">
      <div className="header-contact-infos__icon">
        <UserPhoto letterIcon={attendant.label} size="large" />
        <Typography.H4 color={"gray-600"}>{attendant.label}</Typography.H4>
      </div>
      <div className="header-contact-infos__actions">
        <Tooltippy content={"Falar com atendente"}>
          <button
            className={`action-button ${typeMonitoring === 0 ? "active" : ""} ${
              hasVoice ? "disabled" : ""
            }`}
            onClick={() => {
              setTypeMonitoring(0);
              InitialCall(ChatSimult, attendant);
            }}
          >
            <CallIcon />
          </button>
        </Tooltippy>

        <Tooltippy content={"Escuta sigilosa"}>
          <button
            className={`action-button ${typeMonitoring === 1 ? "active" : ""}`}
            onClick={() => {
              setTypeMonitoring(1);
              InitialMonitoringAction(
                InfoUsers.id,
                attendant.iduser,
                attendant.label,
                MonitoringSimult,
                "1",
                attendant.ramal,
              );
            }}
          >
            <ListeningIcon />
          </button>
        </Tooltippy>

        <Tooltippy content={"Sussuro"}>
          <button
            className={`action-button ${typeMonitoring === 2 ? "active" : ""} ${
              (selectedChat && parseInt(selectedChat.idmidia) === 3) ||
              (selectedChat && parseInt(selectedChat.idmidia) === 1) ||
              (selectedChat && parseInt(selectedChat.idmidia) === 16)
                ? "disabled"
                : ""
            }`}
            onClick={() => {
              if (!selectedChat && Array.isArray(ClientUserMonitors)) {
                const filterClients = ClientUserMonitors.filter(
                  (client) =>
                    parseInt(Monitoring.userout) === parseInt(client.monuser),
                );
                const hasFilterClients =
                  Array.isArray(filterClients) && filterClients.length > 0;
                if (hasFilterClients) {
                  setSelectedChat(filterClients[0]);
                }
              }
              setTypeMonitoring(2);
              InitialMonitoringAction(
                InfoUsers.id,
                attendant.iduser,
                attendant.label,
                MonitoringSimult,
                "2",
                attendant.ramal,
              );
            }}
          >
            <SussurroIcon />
          </button>
        </Tooltippy>

        <Tooltippy content={"Intercalar"}>
          <button
            className={`action-button ${typeMonitoring === 3 ? "active" : ""} ${
              (selectedChat && parseInt(selectedChat.idmidia) === 3) ||
              (selectedChat && parseInt(selectedChat.idmidia) === 1) ||
              (selectedChat && parseInt(selectedChat.idmidia) === 16)
                ? "disabled"
                : ""
            }`}
            onClick={() => {
              if (!selectedChat && Array.isArray(ClientUserMonitors)) {
                const filterClients = ClientUserMonitors.filter(
                  (client) =>
                    parseInt(Monitoring.userout) === parseInt(client.monuser),
                );
                const hasFilterClients =
                  Array.isArray(filterClients) && filterClients.length > 0;
                if (hasFilterClients) {
                  setSelectedChat(filterClients[0]);
                }
              }
              setTypeMonitoring(3);
              InitialMonitoringAction(
                InfoUsers.id,
                attendant.iduser,
                attendant.label,
                MonitoringSimult,
                "3",
                attendant.ramal,
              );
            }}
          >
            <PointMessageIcon />
          </button>
        </Tooltippy>

        {/* {selectedChat &&
          !openDetails &&
          parseInt(selectedChat.idmidia) !== 1 && (
            <Tooltippy content={"Detalhes"}>
              <button
                className={`action-button`}
                onClick={() => {
                  setOpenDetails(true);
                }}
              >
                <InfoCircle />
              </button>
            </Tooltippy>
          )} */}
      </div>
    </div>
  );
};

export default HeaderContactInfos;
